import { createReducer } from 'redux-create-reducer'
import {
  PLAYLIST_SHARE_SUCCESS,
  PLAYLIST_SHARES_LOADING_SUCCESS,
} from '@disco/constants/ActionTypes'
const initialState: object = {}

function replaceContactsWithId(recipients) {
  return recipients.map(rec => {
    if (rec.contact) {
      return { ...rec, contact: rec.contact.id }
    } else {
      return rec
    }
  })
}

export function normalize(share) {
  return { ...share, recipients: replaceContactsWithId(share.recipients) }
}

export type PlaylistSharesState = typeof initialState
export const playlistSharesReducer = createReducer<PlaylistSharesState, any>(
  initialState,
  {
    [PLAYLIST_SHARE_SUCCESS](state, action) {
      const { id } = action.result
      const update = {
        [id]: { ...(state[id] || {}), ...normalize(action.result) },
      }
      return { ...state, ...update }
    },

    [PLAYLIST_SHARES_LOADING_SUCCESS](state, { responseShares }) {
      const update = {}
      responseShares.forEach(item => (update[item.id] = normalize(item)))
      return { ...state, ...update }
    },
  },
)
